import { render, staticRenderFns } from "./circularStrategy2.vue?vue&type=template&id=3ce1bf4b&scoped=true&"
import script from "./circularStrategy2.vue?vue&type=script&lang=ts&"
export * from "./circularStrategy2.vue?vue&type=script&lang=ts&"
import style0 from "./circularStrategy2.vue?vue&type=style&index=0&id=3ce1bf4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce1bf4b",
  null
  
)

export default component.exports